import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomSnackbar from './../shared/custom_snackbar';
import { Button, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { resetBeneficiarioState, fetchGuia } from '@store/actions/index';
import m from '@utils/strings';

class AreaResultadoAutorizado extends Component {
    state = {
        copied: false
    }

    resetBeneficiarioState = () => {
        this.props.setInitialFieldsState();
        this.props.resetBeneficiarioState();
    }

    onCopy = () => {
        this.setState({ copied: true });
    }

    render() {
        const { beneficiario } = this.props;
        return (
            <div style={{ marginRight: 365, marginTop: 10}}>                
                <Grid columns='equal' >
                    <Grid.Column key='1'> 
                        <div className={"div-area-resultado-autorizacao-ps"}>
                            <label id={"label-sucesso-servico"}>
                                {m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_ATENDIMENTO_AUTORIZADO}
                            </label>
                            <div className={"div-separador-top-10"}>
                                <label id={"label-senha"}>{m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_SENHA}</label>
                            </div>
                            <div className={"div-separador-top-10"}>
                                <label id={"label-senha-numero"} style={{fontSize: 20}}>
                                    { beneficiario.data.SolicitacaoProcedimento.Senha }
                                </label>
                                <div className={"div-separador-top-10"}>
                                    <CopyToClipboard text={beneficiario.data.SolicitacaoProcedimento.Senha}
                                        onCopy={this.onCopy}>
                                        <label onClick={this.dispatchSenhaSnackbar} id={"label-copiar"}>{m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_COPIAR}</label>
                                    </CopyToClipboard>
                                </div>
                            </div>
                            
                            <CustomSnackbar
                                setClick={click => this.dispatchSenhaSnackbar = click}
                                variant="success"
                                duration={1000}
                                content={m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_SENHA_COPIADA}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column key='2'> 
                        <div className={"div-area-resultado-guia"}>
                            <div className={"div-separador-top-10"}>
                                <label id={"label-senha"}>{m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_GUIA}</label>
                            </div>
                            <div className={"div-separador-top-10"}>
                                <label id={"label-senha-numero"} style={{fontSize: 20}}>
                                    { beneficiario.data.SolicitacaoProcedimento.NumeroGuiaOperadora }
                                </label>
                                <div className={"div-separador-top-10"}>
                                    <CopyToClipboard text={beneficiario.data.SolicitacaoProcedimento.NumeroGuiaOperadora}
                                        onCopy={this.onCopy}>
                                        <label onClick={this.dispatchGuiaSnackbar} id={"label-copiar"}>{m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_COPIAR}</label>
                                    </CopyToClipboard>
                                </div>
                            </div>

                            <div 
                                className={"div-separador-top-10"} 
                                style={{ cursor: 'pointer', marginTop: 15, width: '200' }}
                                title={ m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_INFORMATIVO_IMPRIMIR_GUIA_PS }
                                onClick={() => {
                                    this.setState({ showGuiaLoader: true });
                                    this.props.fetchGuia(beneficiario.data.SolicitacaoProcedimento.Senha, 
                                        (result) => {
                                            this.setState({ showGuiaLoader: false })
                                            const url = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }));
                                            const link = document.createElement('a');
                                            link.href = url;
                                            link.setAttribute('target', '_blank');
                                            document.body.appendChild(link);
                                            link.click();
                                        },
                                        (error) => {
                                            this.setState({ showGuiaLoader: false })
                                            this.setState({ snackbarMsg: m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_IMPRESSAO });
                                            this.clickChild();
                                        })
                                }}
                            >
                                <div style={{ color: 'rgb(137, 137, 137)', fontFamily: "Source Code Pro" }}> 
                                    <img 
                                        src="../images/print.png" 
                                        alt="Imprimir" 
                                        style={{ marginRight: 10 }}
                                    />
                                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_IMPRIMIR_GUIA}
                                    <img
                                        src="../images/info.png"
                                        alt="info"
                                        title={ m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_INFORMATIVO_IMPRIMIR_GUIA_PS }
                                        style={{
                                            marginRight: 10,
                                            marginLeft: 10,
                                            width: 13,
                                            marginTop: -15
                                        }}
                                    />
                                </div>
                            </div>
                            
                            <CustomSnackbar
                                setClick={click => this.dispatchGuiaSnackbar = click}
                                variant="success"
                                duration={1000}
                                content={m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_GUIA_COPIADA}
                            />
                        </div>
                    </Grid.Column>
                </Grid>
                <div className={"div-separador-top-bottom-25"}>
                    <hr className={"hr-class"} style={{marginLeft: 50, marginRight: 99 }}/>
                </div>
                <div className={"div-separador-top-10"}>
                    <Button
                        onClick={this.resetBeneficiarioState}
                        className={"btn-default-cemig"} 
                        style={{ marginLeft: 50 }}>
                            {m.TELA_CONSULTA_PRONTO_SOCORRO.LABEL_NOVO_ATENDIMENTO} (ENTER)
                    </Button>
                </div>
            </div>
        )
    }
}

export default connect(null, { resetBeneficiarioState, fetchGuia })(AreaResultadoAutorizado)
